<div class="flex flex-col h-full">
  @if (showStepsHeader) {
    <!-- Header - Sticky to top -->
    <div class="flex-shrink-0 sticky top-0 bg-white dark:bg-slate-700 z-10 p-4">
      @switch (+step) {
        @case (1) {
          <div class="flex flex-row justify-between items-center">
            <p class="text-3xl sm:text-xl font-semibold">Shopping Cart</p>
            <button
              mat-icon-button
              (click)="onCloseDrawer()"
              *ngIf="showCloseButton">
              <mat-icon class="close-button">close</mat-icon>
            </button>
          </div>
          <p class="text-sm" *ngIf="!selectedQR">
            {{ queuedQR.length }} Bonds - Total:
            {{ subtotal | currency: 'USD' }}
          </p>
        }
        @case (2) {
          <div class="flex flex-row items-center justify-between">
            <div class="mr-4">
              <button mat-icon-button (click)="onMoveBack()">
                <mat-icon>arrow_back</mat-icon>
              </button>
            </div>
            <div class="flex flex-col align-center items-center">
              <p class="text-3xl sm:text-xl font-semibold">Checkout</p>
              <p class="text-sm" *ngIf="!selectedQR">
                {{ queuedQR.length }} Bonds - Total:
                {{ subtotal | currency: 'USD' }}
              </p>
            </div>
            <div class="ml-4">
              <button mat-icon-button (click)="onCloseDrawer()">
                <mat-icon class="close-button">close</mat-icon>
              </button>
            </div>
          </div>
        }
        @case (3) {
          <div class="flex flex-row items-center justify-between">
            <div class="mr-4">
              <button mat-icon-button (click)="onMoveBack()">
                <mat-icon>arrow_back</mat-icon>
              </button>
            </div>
            <div class="flex flex-col align-center items-center">
              <p class="text-3xl sm:text-xl font-semibold">Checkout</p>
              <p class="text-sm" *ngIf="!selectedQR">
                {{ queuedQR.length }} Bonds - Total:
                {{ subtotal | currency: 'USD' }}
              </p>
            </div>
            <div class="ml-4">
              <button mat-icon-button (click)="onCloseDrawer()">
                <mat-icon class="close-button">close</mat-icon>
              </button>
            </div>
          </div>
        }
        @case (4) {
          <div class="flex flex-row items-center justify-between">
            <div class="mr-4">
              <button mat-icon-button (click)="onMoveBack()">
                <mat-icon>arrow_back</mat-icon>
              </button>
            </div>
            <div class="flex flex-col align-center items-center">
              <p class="text-3xl sm:text-xl font-semibold">Checkout</p>
              <p class="text-sm" *ngIf="!selectedQR">
                {{ queuedQR.length }} Bonds - Total:
                {{ total | currency: 'USD' }}
              </p>
            </div>
            <div class="ml-4">
              <button mat-icon-button (click)="onCloseDrawer()">
                <mat-icon class="close-button">close</mat-icon>
              </button>
            </div>
          </div>
        }
        @case (5) {
          @if (isPurchased) {
            <div class="flex flex-row items-center justify-between">
              <div class="mr-4">
                <button
                  mat-icon-button
                  (click)="onMoveBack()"
                  class="invisible">
                  <mat-icon>arrow_back</mat-icon>
                </button>
              </div>
              <div class="flex flex-col align-center items-center">
                <p class="text-3xl sm:text-xl font-semibold">
                  Order Confirmation
                </p>
                <p class="text-sm" *ngIf="!selectedQR">
                  {{ isPurchased ? recentlyPurchasedCount : queuedQR.length }}
                  Bond{{ queuedQR.length > 1 ? 's' : '' }} - Total:
                  {{ total | currency: 'USD' }}
                </p>
              </div>
              <div class="ml-4">
                <button mat-icon-button (click)="onCloseDrawer()">
                  <mat-icon class="close-button">close</mat-icon>
                </button>
              </div>
            </div>
          }
        }
      }
    </div>
    <mat-divider class="mb-4"></mat-divider>
    @if (step < 4) {
      <sbd-account-portal-frontend-drawer-breadcrumb
        class="px-2"
        [titles]="['Delivery', 'Payment', 'Review']"
        [position]="step - 1"></sbd-account-portal-frontend-drawer-breadcrumb>
    }
  }

  <!-- Middle - Scrollable content -->
  <div class="flex-1 overflow-auto px-4">
    <ng-content></ng-content>
  </div>

  <!-- Footer - Sticky to bottom -->
  @if (step < 5 && !selectedQR && queuedQR.length > 0) {
    <div
      class="flex-shrink-0 sticky bottom-0 bg-white dark:bg-slate-700 px-4 pb-4">
      <mat-divider class="mb-4"></mat-divider>
      <div
        class="my-4 flex flex-row justify-between text-xl sm:text-md"
        *ngIf="step === 1">
        <div class="flex flex-col">
          <span class="text-xl sm:text-md font-semibold">SubTotal</span>
          <span class="text-sm text-gray-400">
            Shipping Calculated at Checkout
          </span>
        </div>
        <span class="text-xl sm:text-md font-semibold">
          {{ subtotal | currency: 'USD' }}
        </span>
      </div>
      @if (step > 1) {
        <div class="my-4 flex flex-col text-xl sm:text-md">
          <div class="flex flex-row justify-between">
            <span class="text-md sm:text-sm">
              {{
                step < 4 ? 'SubTotal' : queuedQR.length > 1 ? 'Bonds' : 'Bond'
              }}
            </span>
            <span class="text-xl sm:text-md font-semibold">
              {{ subtotal | currency: 'USD' }}
            </span>
          </div>
          <div class="flex flex-row justify-between">
            <span class="text-md sm:text-sm">Shipping</span>
            <span class="text-xl sm:text-md font-semibold">
              {{ shippingTotal | currency: 'USD' }}
            </span>
          </div>
        </div>

        <div class="my-4 flex flex-row justify-between text-xl sm:text-md">
          <span class="text-xl sm:text-md font-semibold">Total</span>
          <span class="text-xl sm:text-md font-semibold">
            {{ total | currency: 'USD' }}
          </span>
        </div>
      }
      <div class="flex flex-row justify-end align-right items-end w-full gap-2">
        <button
          mat-button
          class="border-2 md:w-3/12 w-6/12"
          (click)="onMoveBack()"
          *ngIf="step === 2">
          Back to Cart
        </button>
        <button
          mat-flat-button
          class="text-white md:w-3/12 w-6/12"
          [color]="'primary'"
          type="button"
          (click)="onMoveToNextStep()"
          [disabled]="isPurchasing">
          @switch (step) {
            @case (1) {
              Checkout Now
            }
            @case (2) {
              Proceed to Payment
            }
            @case (3) {
              Review Order
            }
            @case (4) {
              Complete Order
            }
          }
        </button>
      </div>
    </div>
  }
</div>
